import { Fragment, useEffect } from "react";
import { timerMobileStyle, timerStyle } from "./styles";
import { getNextCollectionDay, useWeekStreak } from "../../hooks";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import Countdown from "components/CountdownV2";
import { useDailyLoginStreak } from "../../context";
import { useAppDispatch } from "hooks";
import { getDailyLoginStreak } from "redux/slices";
import useBreakpoints from "hooks/useBreakpoints";
import { useMediaQuery } from "@mui/material";
import { getCount, getDisplay, getTimeLeft } from "utils/time";

export const Timer: React.FC = ({}) => {
	const dispatch = useAppDispatch();
	const { isMdDown } = useBreakpoints();
	const { nowTime } = useWebStoreContext();
	const { tracker } = useDailyLoginStreak();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { streakDays, lastDayCollected, isStreakBroken } = tracker;
	const { today, tomorrow } = useWeekStreak(streakDays);
	const isSmallLandscape = useMediaQuery(
		"(max-width:932px) and (max-height:430px)"
	);
	const alreadyCollected = today && "collectedDate" in today;
	let endTime: string;

	if (lastDayCollected || !alreadyCollected) {
		endTime = today?.endOfDay;
	} else {
		endTime = tomorrow?.startOfDay;
	}

	const handleEnd = () => {
		dispatch(getDailyLoginStreak());
	};

	useEffect(() => {
		const timeRemaining = getCount(nowTime, endTime);
		const timeToDisplay = getDisplay(timeRemaining);
		reportEvent("daily_gift_streak_view", {
			gifts_claimed:
				getNextCollectionDay(tracker)?.streakDayIndex ?? streakDays.length,
			time_remaining: timeToDisplay,
			collected_state: alreadyCollected ?? false,
			broke_streak: isStreakBroken ?? false,
			source: "daily_gift_streak"
		});
		const timeLeft = getTimeLeft(nowTime, endTime, "seconds");
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "daily_gift_streak_view",
			event_type: "web_daily_login_streak",
			action: "daily_gift_streak_view",
			source: "daily_gift_streak",
			node_type:
				getNextCollectionDay(tracker)?.streakDayIndex.toString() ??
				streakDays.length.toString(),
			time_left: timeLeft,
			progress_status: alreadyCollected ? "true" : "false",
			status: isStreakBroken ? "true" : "false"
		});
	}, []);

	return today && endTime ? (
		<Countdown
			onEnd={() => handleEnd()}
			endTime={endTime}
			style={isSmallLandscape || isMdDown ? timerMobileStyle : timerStyle}
			startTime={nowTime}
			text={alreadyCollected ? "Next Free Gift:" : "Time to collect:"}
			status={alreadyCollected ? "Next Free Gift:" : "Time to collect:"}
		/>
	) : (
		<Fragment />
	);
};
